export default "__VITE_ASSET__BPwvFZ1T__"